import { createStore, compose } from 'redux';
import rootReducer from './reducers'

const composeEnhancers = compose;
const initialState = {}

const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers()
)

export default store;